__turbopack_context__.v({
  "narrow": "class-table-module__vp_wzW__narrow",
  "wide": "class-table-module__vp_wzW__wide",
  "wrapper": "class-table-module__vp_wzW__wrapper",
});
